import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";

const LevelDropdown = (props) => {
  const {
    onChange,
    name,
    defaultValue,
    width = "90%",
    projectId,
    allowClear = false,
  } = props;
  const [levelData, setLevelData] = useState([]);

  const getAlllevel = async () => {
    try {
      const response = await apiGet(`/v1/${projectId}/levels`, false);
      const responseData = response.data;

      const levelData = responseData.map((level) => ({
        id: level.id,
        label: level.name,
      }));
      setLevelData(levelData);
    } catch (error) {
      console.error("Error fetching level data:", error);
    }
  };

  useEffect(() => {
    getAlllevel();
  }, [projectId]);

  const handleDropdownChange = (value) => {
    const selectedOption = levelData.find((item) => item.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    // Pass both value and label to the onChange handler
    onChange(name, value, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      placeholder="Select level"
      options={levelData}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={true}
      width={width}
      dropdowType={"LevelDropdown"}
      allowClear={allowClear}
    />
  );
};

export default LevelDropdown;
